import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "model";
/**
* @class StopPayment
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.paymentTransaction[0];
* const payment = new PaymentTransaction(record);
* @property {NUMBER} _id - The id of the payment related transaction data
* @property {NUMBER} _startCheck - the number on the payment
* @property {STRING} _endCheck - memo on payment
* @property {NUMBER} _amount - The id of the bill related
* @property {NUMBER} _effective - The id of the payment related transaction data
* @property {NUMBER} _payee - the number on the payment
* @property {STRING} _checkDate - memo on payment
* @property {NUMBER} _checkTime - The id of the bill related
* @property {NUMBER} _account - The id of the bill related
* @property {NUMBER} _reason - The reason for stop payment
* @property {BOOLEAN} _agreeToStopPaymentFee - The agreeToStopPaymentFee value of the payment.
*/
export default class StopPayment extends BCMSRecord{
    _id;   
    _startCheck;  
    _endCheck;   
    _amount;
    _effective;
    _payee;   
    _checkDate;  
    _checkTime;   
    _account;
    _reason;
    _agreeToStopPaymentFee;

    constructor (record){   
      super(record) 
    }    
  } 
  StopPayment.define({
    "recordType":"stopPayment",
    "recordIDProp":"id",
    "className" : "StopPayment",
    "recordProperties":[
      /** 
      * @name id
      * @instance
      * @property get {NUMBER} - gets the id of the payment
      * @property set {NUMBER} - sets the id of the payment
      * @memberof StopPayment 
      */
      BCMSRecordProperty.mapToNumber("id","_id"),
      /** 
      * @name startCheck
      * @instance
      * @property get {NUMBER} - gets the startCheck of the payment
      * @property set {NUMBER} - sets the startCheck of the payment
      * @memberof StopPayment 
      */
      BCMSRecordProperty.mapToNumber("startCheck","_startCheck"),
      /** 
      * @name endCheck
      * @instance
      * @property get {STRING} - gets the endCheck of the payment
      * @property set {STRING} - sets the endCheck of the payment
      * @memberof StopPayment 
      */
      BCMSRecordProperty.mapToString("endCheck","_endCheck"),
       /** 
      * @name amount
      * @instance
      * @property get {BCMSCurrency} - gets the amount of the payment
      * @property set {BCMSCurrency} - sets the amount of the payment
      * @memberof StopPayment 
      */
        BCMSRecordProperty.mapToCurrency("amount","_amount"),
    /** 
      * @name effective
      * @instance
      * @property get {BCMSDate} - gets the effective of the payment
      * @property set {BCMSDate} - sets the effective of the payment
      * @memberof StopPayment 
      */
      BCMSRecordProperty.mapToDate("effective","_effective"),
      /** 
       * @name payee
       * @instance
       * @property get {NUMBER} - gets the payee of the payment
       * @property set {NUMBER} - sets the payee of the payment
       * @memberof StopPayment 
       */
      BCMSRecordProperty.mapToString("payee","_payee"),
      /** 
       * @name checkDate
       * @instance
       * @property get {BCMSDate} - gets the checkDate of the payment
       * @property set {BCMSDate} - sets the checkDate of the payment
       * @memberof StopPayment 
       */
      BCMSRecordProperty.mapToDate("checkDate","_checkDate"),

      /**
        * @name checkTime
        * @instance
        * @property get {String} - gets the checkTime of the payment
        * @property set {String} - sets the checkTime of the payment
        * @memberof StopPayment
        */
      BCMSRecordProperty.mapToString("checkTime", "_checkTime"),
      /**
       * @name account
       * @instance
       * @property get {account} - gets the account of the payment
       * @property set {account} - sets the account of the payment
       * @memberof StopPayment
       */
      BCMSRecordProperty.mapToClass("account", "_account", () => Account),

      /**
      * @name reason
      * @instance
      * @property get {String} - gets the reason of the payment
      * @property set {String} - sets the reason of the payment
      * @memberof StopPayment
      */
        BCMSRecordProperty.mapToString("reason", "_reason"),

      /**
       * @name agreeToStopPaymentFee
       * @instance
       * @property get {STRING} - gets the agreeToStopPaymentFee value of the payment
       * @property set {STRING} - sets the agreeToStopPaymentFee value of the payment
       * @memberof Deposit
       */
      BCMSRecordProperty.mapToBoolean("agreeToStopPaymentFee", "_agreeToStopPaymentFee"),
    ]
})




